import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataResponseWrapper } from '../classes/core/api/data-response-wrapper';
import { PagedCollectionFilterResponseWrapper } from '../classes/core/api/paged-collection-filter-response-wrapper';
import { SnackbarService } from '../services/general/snackbar.service';

@Injectable()
export class ResponseWrapperInterceptor implements HttpInterceptor {
    constructor(private snackbarService: SnackbarService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map(event => {
                if (event instanceof HttpResponse && event.body != undefined) {
                    // We need to check the type of event, if it is a PageCollectionFilterResponseWrapper we need to include the filter property
                    // TODO: Probably look at changing the search.api returned type to include this in data T

                    let responseBody = event.body;
                    if (
                        this.isPagedCollectionFilterResponseWrapper(
                            responseBody
                        )
                    ) {
                        let pagedCollectionFilterResponseWrapper =
                            new PagedCollectionFilterResponseWrapper<any>(
                                responseBody.filterWrapper,
                                responseBody.data,
                                responseBody.nextPage,
                                responseBody.previousPage,
                                responseBody.totalResults,
                                responseBody.success,
                                responseBody.message
                            );
                        Object.assign(
                            pagedCollectionFilterResponseWrapper,
                            responseBody
                        );
                        if (!pagedCollectionFilterResponseWrapper.success) {
                            this.snackbarService.Show(
                                `Backend returned unsuccessful response, message was: ${pagedCollectionFilterResponseWrapper.message}`
                            );
                            console.error(
                                `Backend returned unsuccessful response, message was: ${pagedCollectionFilterResponseWrapper.message}`
                            );
                            return event;
                        }
                    } else {
                        let dataResponseWrapper = new DataResponseWrapper(
                            responseBody.success,
                            responseBody.message,
                            responseBody.data
                        );
                        Object.assign(dataResponseWrapper, responseBody);
                        if (
                            dataResponseWrapper.success &&
                            !dataResponseWrapper.success
                        ) {
                            this.snackbarService.Show(
                                `Backend returned unsuccessful response, message was: ${dataResponseWrapper.message}`
                            );
                            console.error(
                                `Backend returned unsuccessful response, message was: ${dataResponseWrapper.message}`
                            );
                            return event;
                        }
                    }

                    if (
                        this.isPagedCollectionFilterResponseWrapper(
                            responseBody
                        )
                    ) {
                        let pagedCollectionFilterResponseWrapper =
                            new PagedCollectionFilterResponseWrapper<any>(
                                responseBody.filterWrapper,
                                responseBody.data,
                                responseBody.nextPage,
                                responseBody.previousPage,
                                responseBody.totalResults,
                                responseBody.success,
                                responseBody.message
                            );
                        const modEvent = event.clone({
                            body: pagedCollectionFilterResponseWrapper
                        });
                        return modEvent;
                    } else {
                        const modEvent = event.clone({
                            body: responseBody.data
                        });
                        return modEvent;
                    }
                }
            })
        );
    }

    // We need to do a custom type check here as type checking in Typescript/Javascript is weird
    // https://rangle.io/blog/how-to-use-typescript-type-guards/
    private isPagedCollectionFilterResponseWrapper = (
        variableToCheck: any
    ): variableToCheck is PagedCollectionFilterResponseWrapper<any> =>
        (variableToCheck as PagedCollectionFilterResponseWrapper<any>)
            .nextPage !== undefined;
}
